import React from "react";
import { Switch, Route } from "react-router";
import customer from "../customers";
import expense from "../expense";
import enquiry from "../misc/Enquiry";
import float from "../misc/Float";
import cheque from "../misc/Cheque";
import closeCash from "../misc/CloseCash";
import cashTotal from "../misc/CashTotal";
import cashAdd from "../misc/CashAdd";
import cashDrop from "../misc/CashDrop";
import todayCollection from "../reports/TodayCollection";
import cancellation from "../reports/Cancellation";
import billPayment from "../reports/BillPayment";
import receivings from "../receivings";
import product from "../products";
import vendor from "../vendor";
import sale from "../sale";
import NotFound from "../notFound/NotFound";
import dashboard from '../dashboard';

const Routes = () => (
  <Switch style={{ overflow: "auto" }}>
    <Route exact path="/" component={dashboard} />

    {/* Sale */}
    <Route exact path="/sale" component={sale} />

    {/* Sale */}
    <Route exact path="/sale" component={sale} />

    {/* Receivings */}
    <Route exact path="/receivings" component={receivings.Receivings} />
    <Route exact path="/receivings/new" component={receivings.AddNew} />

    {/* Vendor */}
    <Route exact path="/vendors" component={vendor.Vendors} />
    <Route exact path="/vendors/new" component={vendor.AddNew} />
    <Route exact path="/vendors/edit/:id" component={vendor.AddNew} />

    {/* Customer */}
    <Route exact path="/customers" component={customer.Customers} />
    <Route exact path="/customers/new" component={customer.AddNew} />
    <Route exact path="/customers/edit/:id" component={customer.AddNew} />

    {/* Expense */}
    <Route exact path="/expense" component={expense.Expense} />
    <Route exact path="/expense/new" component={expense.AddNewExpense} />
    <Route exact path="/expense/edit/:id" component={expense.AddNewExpense} />

    {/* MISC */}
    <Route exact path="/enquiry" component={enquiry} />
    <Route exact path="/float" component={float} />
    <Route exact path="/cheque" component={cheque} />
    <Route exact path="/closeCash" component={closeCash} />
    <Route exact path="/cashTotal" component={cashTotal} />
    <Route exact path="/cashAdd" component={cashAdd} />
    <Route exact path="/cashDrop" component={cashDrop} />
    
    {/* Report */}
    <Route exact path="/todayCollection" component={todayCollection} />
    <Route exact path="/cancellation" component={cancellation} />
    <Route exact path="/billPayment" component={billPayment} />

    
    {/* Expense Type */}
    <Route exact path="/expensetypes" component={expense.Expense} />
    <Route
      exact
      path="/expensetypes/new"
      component={expense.AddNewExpenseType}
    />
    <Route
      exact
      path="/expensetypes/edit/:id"
      component={expense.AddNewExpenseType}
    />

    {/* Product */}
    <Route exact path="/products" component={product.Products} />
    <Route exact path="/products/new" component={product.AddNewProduct} />
    <Route exact path="/products/edit/:id" component={product.AddNewProduct} />

    {/* Product Type */}
    <Route exact path="/producttypes" component={product.Products} />
    <Route
      exact
      path="/producttypes/new"
      component={product.AddNewProductType}
    />
    <Route
      exact
      path="/producttypes/edit/:id"
      component={product.AddNewProductType}
    />

    {/* Catch : Not found */}
    <Route path="/" component={NotFound} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/components/home/Routes.js